<template>
    <div>
        <modal v-model="extraData" dir="right" :modalClass="['fill', 'md right h100']" title="Secciones Personalizadas">
        <i class="options icon-information" slot="options" @click="modalInstructions = true" v-tooltip="'Instrucciones de uso'"></i>
        <i class="options icon-plus" slot="options" @click="AddSection" v-tooltip="'Nueva sección'"></i>
        <div v-if="extraData" class="pa20">
            <draggable
                :list="extraData"
                v-show="extraData.length"
                handle=".handle"
                :animation="200"
                group="sections"
            >
                <div class="flex well mb10" v-for="(item, index) in extraData" :key="index">
                    <div class="flex-fill">
                        <div class="flex align-center mb5" style="justify-content: space-between;">
                            <div class="flex align-center bold">
                                <i class="icon icon-drag-handle handle"></i>
                                Sección {{ index + 1 }}
                            </div>
                            <div class="flex align-center">
                                <input-files class="mr5" @OnUploadFile="OnUploadFile($event, index)" icon="plus" :maxImgSize="1000" v-tooltip="'Agregar archivo'"/>
                                <i class="options icon-trash c4" @click.stop="RemoveSection(index)" v-tooltip="'Eliminar sección'"></i>
                            </div>
                        </div>
                        <input-field v-model="item.title" placeholder="Nombre" class="mb10"/>
                        <input-field v-model="item.content" label="Contenido" :lines="true" class="pre-line"
                        placeholder="Ejemplo:
                        
                        # Menú
                        *Hamburguesa* con /queso/
                        - Coca Cola
                        [ver más](www.ejemplo.com)
                        ![imagen](https://miweb.com/menu.png)
                        [pdf](https://miweb.com/menu.pdf)
                        [video](https://miweb.com/menu.mp4)"
                        />
                    </div>
                </div>
            </draggable>
        </div>
        <button slot="actions" class="primary purple" @click="Save"> Aceptar</button>
    </modal>
    <modal v-model="modalInstructions" title="Instrucciones de uso" hideActions>
        <div class="pa20" v-html="instructiosContent"></div>
    </modal>
    </div>

</template>

<script>
export default {
    data() {
        return {
            extraData: null,
            modalInstructions : false
        }
    },
    computed: {
        instructiosContent() {
            return `
            <div style='max-width:280px; line-height:1.4'>
                <strong>Títulos:</strong>
                <br>
                # Título → principal <br>
                ## Subtítulo → secundario <br>
                <br>
                <strong>Texto:</strong> <br>
                *texto* → <strong>negrita</strong> <br>
                /texto/ → <em>cursiva</em> <br>
                _texto_ → <u>subrayado</u> <br>
                <br>
                <strong>Combinar:</strong> <br>
                *_texto_* | /_texto_/ | */texto/* <br>
                <br>
                <strong>Lista</strong> <br>
                - item <br>
                - item <br>
                <br>
                <strong>Enlaces</strong> <br>
                [texto](url) <br>
                <br>
                <strong>Imágenes (.jpeg, .jpg, .png, .webp, .gif) </strong> <br>
                [img](url) <br>
                [img]['ancho'x'alto'](url) <br>
                <br>
                <strong>Video (.mp4)</strong> <br>
                [video](url) <br>
                <br>
                <strong>PDF</strong> <br>
                [pdf](url) <br>
            </div>`
        }
    },
    methods: {
        Open(data) {
            if(!data) return;
            this.extraData = data;
        },
        AddSection() {
            this.extraData.push({ title: '', content: '' });
        },
        RemoveSection(index) {
            this.extraData.splice(index, 1);
        },
        OnUploadFile(data, index) {
            if (!data) return;
            let select = this.extraData[index];
            let extension = (data.extension);
            let format = '[link]';

            if (['jpeg', 'jpg', 'png', 'webp','gif'].includes(extension)) format = '[img]';
            else if (extension === 'pdf') format = '[pdf]';
            else if (['mp4', 'webm'].includes(extension)) format = '[video]';

            select.content += `\n${format}(${process.env.VUE_APP_BACKEND_URL}storage/files/${data.key})`;
        },
        Save() {
            let cleaned = this.Util.Copy(this.extraData);
            cleaned = cleaned.filter(item => item.title && item.content);
            this.$emit('OnSave', cleaned);
        },
        Close() {
            this.extraData = null;
        }
    }
}
</script>